import { Component, inject } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { NgxSpinnerComponent } from 'ngx-spinner';
import { NgxSpinnerTextService } from './app/shared/ngx-spinner-text.service';

@Component({
    selector: 'app-root',
    standalone: true,
    template: `
        <router-outlet />
        <ngx-spinner type="ball-clip-rotate" size="medium" color="#5ba7ea">
            @if (ngxSpinnerText) {
                <p>{{ getSpinnerText() }}</p>
            }
        </ngx-spinner>
    `,
    imports: [RouterOutlet, NgxSpinnerComponent],
})
export class RootComponent {
    ngxSpinnerText = inject(NgxSpinnerTextService);

    getSpinnerText(): string {
        return this.ngxSpinnerText.getText();
    }
}
